import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import styled, { css } from 'styled-components';
import Config from '../../config';
import { withTheme } from '../../core/ThemeProvider';
import { getStyledText } from '../../helpers/styled';
var CIRCLE_TO_RING_WIDTH = '10px';
export var Wrapper = styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-1saatch-0"
})(function (_ref) {
  var isVertical = _ref.isVertical;
  return css(["", " display:flex;align-items:stretch;box-sizing:content-box;"], isVertical && css(["flex-direction:column;height:100%;"]));
});
export var VerticalWrapper = styled.div.withConfig({
  displayName: "style__VerticalWrapper",
  componentId: "sc-1saatch-1"
})(css(["display:flex;"]));
export var StepContainer = styled.div.withConfig({
  displayName: "style__StepContainer",
  componentId: "sc-1saatch-2"
})(function (_ref2) {
  var isVertical = _ref2.isVertical;
  return css(["", " ", " ", ""], !isVertical && css(["flex:1;"]), isVertical && css(["justify-content:center;position:relative;height:auto;margin-top:24px;padding-right:20px;"]), function (p) {
    return p.isLast && css(["flex:0;", ";"], !isVertical && Config.media.sm(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        flex: 1;\n      "]))));
  });
});
export var CircleWrapper = styled.div.withConfig({
  displayName: "style__CircleWrapper",
  componentId: "sc-1saatch-3"
})(function (_ref3) {
  var isVertical = _ref3.isVertical;
  return css(["", " align-items:center;position:relative;", ""], !isVertical && css(["display:flex;"]), isVertical && css(["z-index:1;"]));
});
export var Line = styled.div.withConfig({
  displayName: "style__Line",
  componentId: "sc-1saatch-4"
})(function (_ref4) {
  var color = _ref4.color,
    isActive = _ref4.isActive,
    isFirst = _ref4.isFirst,
    isLast = _ref4.isLast,
    isVertical = _ref4.isVertical;
  return css(["", "", " ", ";", " ", " ", " ", " ", " ", " ", " ", " ", ""], isVertical && css(["width:1px;background-color:", ";right:-17px;top:-5px;"], color), !isVertical && css(["flex:1;height:1px;background-color:", ";"], color), isVertical && Config.media.sm(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    right: -20px;\n    top: -10px;\n  "]))), !isActive && !isVertical && css(["position:absolute;right:0;width:100%;"]), isActive && isLast && !isVertical && css(["display:none;"]), isLast && !isVertical && css(["width:", ";left:0;"], CIRCLE_TO_RING_WIDTH), isFirst && !isVertical && css(["width:calc(100% - ", ");"], CIRCLE_TO_RING_WIDTH), !isActive && isVertical && css(["position:relative;height:100%;bottom:0;"]), isActive && isLast && isVertical && css(["display:none;"]), isFirst && isVertical && css(["height:100%;"]), isLast && isVertical && css(["height:", ";top:0;display:none;"], CIRCLE_TO_RING_WIDTH), isActive && isVertical && css(["position:relative;bottom:0;height:100%;"]));
});
export var ActiveBorder = withTheme(styled.div.withConfig({
  displayName: "style__ActiveBorder",
  componentId: "sc-1saatch-5"
})(function (_ref5) {
  var coreTheme = _ref5.coreTheme,
    isActive = _ref5.isActive,
    isVertical = _ref5.isVertical;
  return css(["background:transparent;border-radius:50%;display:flex;justify-content:center;align-items:center;width:34px;height:34px;", ";", ""], Config.media.sm(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        width: 42px;\n        height: 42px;\n      "]))), isActive && css(["border:2px solid ", ";width:30px;height:30px;", " ", ";"], coreTheme.cl_sec_d2, isVertical && css(["background:", ";"], coreTheme.cl_white), Config.media.sm(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            width: 38px;\n            height: 38px;\n          "])))));
}));
export var getCircleText = function getCircleText(isActive) {
  return withTheme(getStyledText(isActive ? 'boldBody' : 'body', {
    lineHeight: 'compact'
  })(function (_ref6) {
    var bgColor = _ref6.bgColor,
      color = _ref6.color,
      coreTheme = _ref6.coreTheme;
    return css(["display:flex;justify-content:center;align-items:center;border-radius:50%;background-color:", ";color:", ";width:", "px;height:", "px;z-index:1;", ";"], bgColor, color, coreTheme.space_6, coreTheme.space_6, Config.media.sm(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n          width: ", "px;\n          height: ", "px;\n        "])), coreTheme.space_8, coreTheme.space_8));
  }));
};
export var TitleWrapper = styled.div.withConfig({
  displayName: "style__TitleWrapper",
  componentId: "sc-1saatch-6"
})(css(["width:100%;margin-top:24px;& > div:first-child{margin-top:0;}"]));
export var Title = withTheme(getStyledText('smallBody', {
  lineHeight: 'compact'
})(function (_ref7) {
  var coreTheme = _ref7.coreTheme;
  return css(["color:", ";padding-top:", "px;padding-right:", "px;"], coreTheme.cl_ter_base, coreTheme.space_2, coreTheme.space_4);
}));